<template>
  <div>
    <el-form :model="form" inline class="search-demo" size="small">
      <el-form-item label="角色名字：">
        <el-input placeholder="请输入角色名字" v-model="form.name"></el-input>
      </el-form-item>
      <div class="search_btn">
        <el-form-item>
          <el-button size="small" @click="resetForm()">清空</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            @click="$emit('search', form)"
            size="small"
            >查找</el-button
          >
        </el-form-item>
        <!-- <el-form-item>
          v-if="pagePermit.includes('_Add')"
          <el-button
            icon="el-icon-plus"
            type="primary"
            @click="$emit('openTitleForm')"
            size="small"
            >新建角色</el-button
          >
        </el-form-item> -->
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getRolePageApi } from '@/api/user.js';
export default {
  props: ['list', 'totalCount'],
  data() {
    return {
      form: {
        name: '',
      },
      path: '',
      fields: {
        角色名: 'name',
        创建时间: 'createTime',
        更新时间: 'updateTime',
        备注: 'remark',
      },
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  methods: {
    resetForm() {
      this.form = {};
      this.$emit('search', this.form);
    },
    async fetchData() {
      let obj = {
        pageSize: this.totalCount,
        pageIndex: 1,
      };
      this.loading = true;
      const res = await getRolePageApi({ ...obj });
      this.loading = false;
      if (res.code !== 200) return [];
      return res.data.dataList;
    },
  },
};
</script>
<style lang="less" scoped>
.topTitle {
  margin: 10px 0 30px 0;
}
.btn button {
  margin-left: 20px;
}
.search-demo {
  margin: 30px 0 10px 55px;
  input {
    height: 35px;
  }
}
.search_btn {
  float: right;
  margin-right: 20px;
}
</style>